import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoticeComponent } from './notice.component';
import { SaveStateData } from 'dbweb-core';
import { RouterModule } from '@angular/router';
import { BillModule } from '../bill/bill.module';
import { MatFormFieldModule, MatCheckboxModule, MatInputModule } from '@angular/material';
import { FormsModule } from '@angular/forms';
import { AceEditorModule } from 'ng2-ace-editor';

@NgModule({
	declarations: [NoticeComponent],
	imports: [
		CommonModule,
		BillModule,
		MatFormFieldModule,
		MatInputModule,
		MatCheckboxModule,
		FormsModule,
		AceEditorModule,
		RouterModule.forChild([
			{
				path: '**',
				component: NoticeComponent,
				data: SaveStateData
			}
		])
	]
})
export class NoticeModule {}
